import { render, staticRenderFns } from "./PageLearnerProfile.vue?vue&type=template&id=00a1ecd1&"
import script from "./PageLearnerProfile.vue?vue&type=script&lang=js&"
export * from "./PageLearnerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports